import { atom } from 'recoil';

export const jobTypesData = atom({
  key: "jobTypesData",
  default: null
});